//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v14.0.7.0 (NJsonSchema v11.0.0.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming

export class BasketClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "https://localhost:44376";
    }

    get(catalog: string, basketId: string | null | undefined): Promise<BasketResponseModel> {
        let url_ = this.baseUrl + "/api/{catalog}/basket?";
        if (catalog === undefined || catalog === null)
            throw new Error("The parameter 'catalog' must be defined.");
        url_ = url_.replace("{catalog}", encodeURIComponent("" + catalog));
        if (basketId !== undefined && basketId !== null)
            url_ += "basketId=" + encodeURIComponent("" + basketId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGet(_response);
        });
    }

    protected processGet(response: Response): Promise<BasketResponseModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BasketResponseModel;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ValidationErrorResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BasketResponseModel>(null as any);
    }

    deleteBasket(catalog: string, basketId: string | null | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/{catalog}/basket?";
        if (catalog === undefined || catalog === null)
            throw new Error("The parameter 'catalog' must be defined.");
        url_ = url_.replace("{catalog}", encodeURIComponent("" + catalog));
        if (basketId !== undefined && basketId !== null)
            url_ += "basketId=" + encodeURIComponent("" + basketId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processDeleteBasket(_response);
        });
    }

    protected processDeleteBasket(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ValidationErrorResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    updateAddresses(catalog: string, basketId: string | null | undefined, addresses: UpdateBasketAddressModel): Promise<BasketResponseModel> {
        let url_ = this.baseUrl + "/api/{catalog}/basket/address?";
        if (catalog === undefined || catalog === null)
            throw new Error("The parameter 'catalog' must be defined.");
        url_ = url_.replace("{catalog}", encodeURIComponent("" + catalog));
        if (basketId !== undefined && basketId !== null)
            url_ += "basketId=" + encodeURIComponent("" + basketId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(addresses);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processUpdateAddresses(_response);
        });
    }

    protected processUpdateAddresses(response: Response): Promise<BasketResponseModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BasketResponseModel;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ValidationErrorResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BasketResponseModel>(null as any);
    }

    updateInvoiceDetails(catalog: string, basketId: string | null | undefined, model: InvoiceDetailRequestModel): Promise<BasketResponseModel> {
        let url_ = this.baseUrl + "/api/{catalog}/basket/invoice-details?";
        if (catalog === undefined || catalog === null)
            throw new Error("The parameter 'catalog' must be defined.");
        url_ = url_.replace("{catalog}", encodeURIComponent("" + catalog));
        if (basketId !== undefined && basketId !== null)
            url_ += "basketId=" + encodeURIComponent("" + basketId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processUpdateInvoiceDetails(_response);
        });
    }

    protected processUpdateInvoiceDetails(response: Response): Promise<BasketResponseModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BasketResponseModel;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ValidationErrorResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BasketResponseModel>(null as any);
    }

    updateNote(catalog: string, basketId: string | null | undefined, note: string): Promise<BasketResponseModel> {
        let url_ = this.baseUrl + "/api/{catalog}/basket/note?";
        if (catalog === undefined || catalog === null)
            throw new Error("The parameter 'catalog' must be defined.");
        url_ = url_.replace("{catalog}", encodeURIComponent("" + catalog));
        if (basketId !== undefined && basketId !== null)
            url_ += "basketId=" + encodeURIComponent("" + basketId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(note);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processUpdateNote(_response);
        });
    }

    protected processUpdateNote(response: Response): Promise<BasketResponseModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BasketResponseModel;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ValidationErrorResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BasketResponseModel>(null as any);
    }

    updateCustomer(catalog: string, basketId: string | null | undefined, requestBody: SetCustomerTypeRequestBody): Promise<BasketResponseModel> {
        let url_ = this.baseUrl + "/api/{catalog}/basket/customer?";
        if (catalog === undefined || catalog === null)
            throw new Error("The parameter 'catalog' must be defined.");
        url_ = url_.replace("{catalog}", encodeURIComponent("" + catalog));
        if (basketId !== undefined && basketId !== null)
            url_ += "basketId=" + encodeURIComponent("" + basketId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(requestBody);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processUpdateCustomer(_response);
        });
    }

    protected processUpdateCustomer(response: Response): Promise<BasketResponseModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BasketResponseModel;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ValidationErrorResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BasketResponseModel>(null as any);
    }

    updateGln(catalog: string, basketId: string | null | undefined, gln: string): Promise<BasketResponseModel> {
        let url_ = this.baseUrl + "/api/{catalog}/basket/gln?";
        if (catalog === undefined || catalog === null)
            throw new Error("The parameter 'catalog' must be defined.");
        url_ = url_.replace("{catalog}", encodeURIComponent("" + catalog));
        if (basketId !== undefined && basketId !== null)
            url_ += "basketId=" + encodeURIComponent("" + basketId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(gln);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processUpdateGln(_response);
        });
    }

    protected processUpdateGln(response: Response): Promise<BasketResponseModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BasketResponseModel;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ValidationErrorResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BasketResponseModel>(null as any);
    }

    updateCvr(catalog: string, basketId: string | null | undefined, cvr: string): Promise<BasketResponseModel> {
        let url_ = this.baseUrl + "/api/{catalog}/basket/cvr?";
        if (catalog === undefined || catalog === null)
            throw new Error("The parameter 'catalog' must be defined.");
        url_ = url_.replace("{catalog}", encodeURIComponent("" + catalog));
        if (basketId !== undefined && basketId !== null)
            url_ += "basketId=" + encodeURIComponent("" + basketId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(cvr);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processUpdateCvr(_response);
        });
    }

    protected processUpdateCvr(response: Response): Promise<BasketResponseModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BasketResponseModel;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ValidationErrorResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BasketResponseModel>(null as any);
    }

    setShipment(catalog: string, basketId: string | null | undefined, shipping: UpdateShippingModel): Promise<BasketResponseModel> {
        let url_ = this.baseUrl + "/api/{catalog}/basket/shipment?";
        if (catalog === undefined || catalog === null)
            throw new Error("The parameter 'catalog' must be defined.");
        url_ = url_.replace("{catalog}", encodeURIComponent("" + catalog));
        if (basketId !== undefined && basketId !== null)
            url_ += "basketId=" + encodeURIComponent("" + basketId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(shipping);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processSetShipment(_response);
        });
    }

    protected processSetShipment(response: Response): Promise<BasketResponseModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BasketResponseModel;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ValidationErrorResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BasketResponseModel>(null as any);
    }

    getShippingMethods(catalog: string, basketId: string | null | undefined): Promise<ShippingMethodReturnModel[]> {
        let url_ = this.baseUrl + "/api/{catalog}/basket/get-shipping-methods?";
        if (catalog === undefined || catalog === null)
            throw new Error("The parameter 'catalog' must be defined.");
        url_ = url_.replace("{catalog}", encodeURIComponent("" + catalog));
        if (basketId !== undefined && basketId !== null)
            url_ += "basketId=" + encodeURIComponent("" + basketId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetShippingMethods(_response);
        });
    }

    protected processGetShippingMethods(response: Response): Promise<ShippingMethodReturnModel[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ShippingMethodReturnModel[];
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ValidationErrorResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ShippingMethodReturnModel[]>(null as any);
    }

    getPickupPoints(catalog: string, providerId: string | undefined, postalCode: string | null | undefined, basketId: string | null | undefined): Promise<PickupPoint[]> {
        let url_ = this.baseUrl + "/api/{catalog}/basket/get-pickup-points?";
        if (catalog === undefined || catalog === null)
            throw new Error("The parameter 'catalog' must be defined.");
        url_ = url_.replace("{catalog}", encodeURIComponent("" + catalog));
        if (providerId === null)
            throw new Error("The parameter 'providerId' cannot be null.");
        else if (providerId !== undefined)
            url_ += "providerId=" + encodeURIComponent("" + providerId) + "&";
        if (postalCode !== undefined && postalCode !== null)
            url_ += "postalCode=" + encodeURIComponent("" + postalCode) + "&";
        if (basketId !== undefined && basketId !== null)
            url_ += "basketId=" + encodeURIComponent("" + basketId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetPickupPoints(_response);
        });
    }

    protected processGetPickupPoints(response: Response): Promise<PickupPoint[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as PickupPoint[];
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as any[];
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PickupPoint[]>(null as any);
    }

    setAcceptTerms(catalog: string, basketId: string | null | undefined, acceptTerms: boolean): Promise<BasketResponseModel> {
        let url_ = this.baseUrl + "/api/{catalog}/basket/accept-terms?";
        if (catalog === undefined || catalog === null)
            throw new Error("The parameter 'catalog' must be defined.");
        url_ = url_.replace("{catalog}", encodeURIComponent("" + catalog));
        if (basketId !== undefined && basketId !== null)
            url_ += "basketId=" + encodeURIComponent("" + basketId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(acceptTerms);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processSetAcceptTerms(_response);
        });
    }

    protected processSetAcceptTerms(response: Response): Promise<BasketResponseModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BasketResponseModel;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ValidationErrorResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BasketResponseModel>(null as any);
    }

    setAcceptNewsletter(catalog: string, basketId: string | null | undefined, acceptNewsletter: boolean): Promise<BasketResponseModel> {
        let url_ = this.baseUrl + "/api/{catalog}/basket/accept-newsletter?";
        if (catalog === undefined || catalog === null)
            throw new Error("The parameter 'catalog' must be defined.");
        url_ = url_.replace("{catalog}", encodeURIComponent("" + catalog));
        if (basketId !== undefined && basketId !== null)
            url_ += "basketId=" + encodeURIComponent("" + basketId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(acceptNewsletter);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processSetAcceptNewsletter(_response);
        });
    }

    protected processSetAcceptNewsletter(response: Response): Promise<BasketResponseModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BasketResponseModel;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ValidationErrorResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BasketResponseModel>(null as any);
    }

    getPaymentMethods(catalog: string, basketId: string | null | undefined): Promise<PaymentMethodModel[]> {
        let url_ = this.baseUrl + "/api/{catalog}/basket/get-payment-methods?";
        if (catalog === undefined || catalog === null)
            throw new Error("The parameter 'catalog' must be defined.");
        url_ = url_.replace("{catalog}", encodeURIComponent("" + catalog));
        if (basketId !== undefined && basketId !== null)
            url_ += "basketId=" + encodeURIComponent("" + basketId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetPaymentMethods(_response);
        });
    }

    protected processGetPaymentMethods(response: Response): Promise<PaymentMethodModel[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as PaymentMethodModel[];
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ValidationErrorResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PaymentMethodModel[]>(null as any);
    }

    getPaymentUrl(catalog: string, basketId: string | null | undefined, paymentMethodId: string | undefined): Promise<string> {
        let url_ = this.baseUrl + "/api/{catalog}/basket/get-payment-url?";
        if (catalog === undefined || catalog === null)
            throw new Error("The parameter 'catalog' must be defined.");
        url_ = url_.replace("{catalog}", encodeURIComponent("" + catalog));
        if (basketId !== undefined && basketId !== null)
            url_ += "basketId=" + encodeURIComponent("" + basketId) + "&";
        if (paymentMethodId === null)
            throw new Error("The parameter 'paymentMethodId' cannot be null.");
        else if (paymentMethodId !== undefined)
            url_ += "paymentMethodId=" + encodeURIComponent("" + paymentMethodId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetPaymentUrl(_response);
        });
    }

    protected processGetPaymentUrl(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ValidationErrorResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }
}

export class LinesClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "https://localhost:44376";
    }

    createLines(catalog: string, basketId: string | null | undefined, itemsModel: AddBasketLineItemsModel): Promise<BasketResponseModel> {
        let url_ = this.baseUrl + "/api/{catalog}/basket/lines?";
        if (catalog === undefined || catalog === null)
            throw new Error("The parameter 'catalog' must be defined.");
        url_ = url_.replace("{catalog}", encodeURIComponent("" + catalog));
        if (basketId !== undefined && basketId !== null)
            url_ += "basketId=" + encodeURIComponent("" + basketId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(itemsModel);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processCreateLines(_response);
        });
    }

    protected processCreateLines(response: Response): Promise<BasketResponseModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BasketResponseModel;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ValidationErrorResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BasketResponseModel>(null as any);
    }

    updateOrCreateLines(catalog: string, basketId: string | null | undefined, itemsModel: AddBasketLineItemsModel): Promise<BasketResponseModel> {
        let url_ = this.baseUrl + "/api/{catalog}/basket/lines?";
        if (catalog === undefined || catalog === null)
            throw new Error("The parameter 'catalog' must be defined.");
        url_ = url_.replace("{catalog}", encodeURIComponent("" + catalog));
        if (basketId !== undefined && basketId !== null)
            url_ += "basketId=" + encodeURIComponent("" + basketId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(itemsModel);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processUpdateOrCreateLines(_response);
        });
    }

    protected processUpdateOrCreateLines(response: Response): Promise<BasketResponseModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BasketResponseModel;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ValidationErrorResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BasketResponseModel>(null as any);
    }

    createLine(catalog: string, basketId: string | null | undefined, itemModel: AddLineItemModel): Promise<BasketResponseModel> {
        let url_ = this.baseUrl + "/api/{catalog}/basket/line?";
        if (catalog === undefined || catalog === null)
            throw new Error("The parameter 'catalog' must be defined.");
        url_ = url_.replace("{catalog}", encodeURIComponent("" + catalog));
        if (basketId !== undefined && basketId !== null)
            url_ += "basketId=" + encodeURIComponent("" + basketId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(itemModel);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processCreateLine(_response);
        });
    }

    protected processCreateLine(response: Response): Promise<BasketResponseModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BasketResponseModel;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ValidationErrorResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BasketResponseModel>(null as any);
    }

    updateOrCreateLine(catalog: string, basketId: string | null | undefined, itemModel: AddLineItemModel): Promise<BasketResponseModel> {
        let url_ = this.baseUrl + "/api/{catalog}/basket/line?";
        if (catalog === undefined || catalog === null)
            throw new Error("The parameter 'catalog' must be defined.");
        url_ = url_.replace("{catalog}", encodeURIComponent("" + catalog));
        if (basketId !== undefined && basketId !== null)
            url_ += "basketId=" + encodeURIComponent("" + basketId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(itemModel);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processUpdateOrCreateLine(_response);
        });
    }

    protected processUpdateOrCreateLine(response: Response): Promise<BasketResponseModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BasketResponseModel;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ValidationErrorResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BasketResponseModel>(null as any);
    }

    delete(catalog: string, id: string[] | null | undefined, basketId: string | null | undefined): Promise<BasketResponseModel> {
        let url_ = this.baseUrl + "/api/{catalog}/basket/line?";
        if (catalog === undefined || catalog === null)
            throw new Error("The parameter 'catalog' must be defined.");
        url_ = url_.replace("{catalog}", encodeURIComponent("" + catalog));
        if (id !== undefined && id !== null)
            id && id.forEach(item => { url_ += "id=" + encodeURIComponent("" + item) + "&"; });
        if (basketId !== undefined && basketId !== null)
            url_ += "basketId=" + encodeURIComponent("" + basketId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processDelete(_response);
        });
    }

    protected processDelete(response: Response): Promise<BasketResponseModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BasketResponseModel;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ValidationErrorResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BasketResponseModel>(null as any);
    }
}

export class OrderClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "https://localhost:44376";
    }

    getOrder(orderId: string, skipTracking: boolean | undefined): Promise<OrderResponseModel> {
        let url_ = this.baseUrl + "/api/order/{orderId}?";
        if (orderId === undefined || orderId === null)
            throw new Error("The parameter 'orderId' must be defined.");
        url_ = url_.replace("{orderId}", encodeURIComponent("" + orderId));
        if (skipTracking === null)
            throw new Error("The parameter 'skipTracking' cannot be null.");
        else if (skipTracking !== undefined)
            url_ += "skipTracking=" + encodeURIComponent("" + skipTracking) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetOrder(_response);
        });
    }

    protected processGetOrder(response: Response): Promise<OrderResponseModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as OrderResponseModel;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ValidationErrorResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<OrderResponseModel>(null as any);
    }
}

export class NewsletterClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "https://localhost:44376";
    }

    post(catalog: string, body: NewsletterPostBody): Promise<void> {
        let url_ = this.baseUrl + "/api/{catalog}/newsletter";
        if (catalog === undefined || catalog === null)
            throw new Error("The parameter 'catalog' must be defined.");
        url_ = url_.replace("{catalog}", encodeURIComponent("" + catalog));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPost(_response);
        });
    }

    protected processPost(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ValidationErrorResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }
}

export class LayerClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "https://localhost:44376";
    }

    getItemImageWithVariantsAndAddons(sku: string, width: number | null | undefined, height: number | null | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/layer/{sku}/image?";
        if (sku === undefined || sku === null)
            throw new Error("The parameter 'sku' must be defined.");
        url_ = url_.replace("{sku}", encodeURIComponent("" + sku));
        if (width !== undefined && width !== null)
            url_ += "width=" + encodeURIComponent("" + width) + "&";
        if (height !== undefined && height !== null)
            url_ += "height=" + encodeURIComponent("" + height) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetItemImageWithVariantsAndAddons(_response);
        });
    }

    protected processGetItemImageWithVariantsAndAddons(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else {
            return response.text().then((_responseText) => {
            let resultdefault: any = null;
            resultdefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, resultdefault);
            });
        }
    }

    getItemImageWithVariantsAndAddons2(sku: string, addonSkus: string): Promise<void> {
        let url_ = this.baseUrl + "/api/layer/{sku}/addons/{addonSkus}/image";
        if (sku === undefined || sku === null)
            throw new Error("The parameter 'sku' must be defined.");
        url_ = url_.replace("{sku}", encodeURIComponent("" + sku));
        if (addonSkus === undefined || addonSkus === null)
            throw new Error("The parameter 'addonSkus' must be defined.");
        url_ = url_.replace("{addonSkus}", encodeURIComponent("" + addonSkus));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetItemImageWithVariantsAndAddons2(_response);
        });
    }

    protected processGetItemImageWithVariantsAndAddons2(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else {
            return response.text().then((_responseText) => {
            let resultdefault: any = null;
            resultdefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, resultdefault);
            });
        }
    }
}

export class CompanyClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "https://localhost:44376";
    }

    cvr(id: string | undefined): Promise<CompanyResponseModel> {
        let url_ = this.baseUrl + "/api/company/cvr?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processCvr(_response);
        });
    }

    protected processCvr(response: Response): Promise<CompanyResponseModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CompanyResponseModel;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else {
            return response.text().then((_responseText) => {
            let resultdefault: any = null;
            resultdefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, resultdefault);
            });
        }
    }

    gln(id: string | undefined): Promise<CompanyResponseModel> {
        let url_ = this.baseUrl + "/api/company/gln?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGln(_response);
        });
    }

    protected processGln(response: Response): Promise<CompanyResponseModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CompanyResponseModel;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 204) {
            return response.text().then((_responseText) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        } else {
            return response.text().then((_responseText) => {
            let resultdefault: any = null;
            resultdefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, resultdefault);
            });
        }
    }
}

export class ProductClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "https://localhost:44376";
    }

    getProduct(productId: string, catalog: string, variantId: string | null | undefined): Promise<ProductModel> {
        let url_ = this.baseUrl + "/api/{catalog}/product/{productId}?";
        if (productId === undefined || productId === null)
            throw new Error("The parameter 'productId' must be defined.");
        url_ = url_.replace("{productId}", encodeURIComponent("" + productId));
        if (catalog === undefined || catalog === null)
            throw new Error("The parameter 'catalog' must be defined.");
        url_ = url_.replace("{catalog}", encodeURIComponent("" + catalog));
        if (variantId !== undefined && variantId !== null)
            url_ += "variantId=" + encodeURIComponent("" + variantId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetProduct(_response);
        });
    }

    protected processGetProduct(response: Response): Promise<ProductModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProductModel;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ValidationErrorResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ProductModel>(null as any);
    }

    inquiry(catalog: string, body: SendProductInquiryRequestBody): Promise<void> {
        let url_ = this.baseUrl + "/api/{catalog}/product/inquiry";
        if (catalog === undefined || catalog === null)
            throw new Error("The parameter 'catalog' must be defined.");
        url_ = url_.replace("{catalog}", encodeURIComponent("" + catalog));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processInquiry(_response);
        });
    }

    protected processInquiry(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }
}

export class ProductCustomizerClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "https://localhost:44376";
    }

    getProductCustomizer(catalog: string, model: ProductCustomizerRequestModel): Promise<CustomizerModel> {
        let url_ = this.baseUrl + "/api/{catalog}/product/get-product-customizer";
        if (catalog === undefined || catalog === null)
            throw new Error("The parameter 'catalog' must be defined.");
        url_ = url_.replace("{catalog}", encodeURIComponent("" + catalog));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetProductCustomizer(_response);
        });
    }

    protected processGetProductCustomizer(response: Response): Promise<CustomizerModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CustomizerModel;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ValidationErrorResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CustomizerModel>(null as any);
    }
}

export class SearchClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "https://localhost:44376";
    }

    search(catalog: string, model: SearchRequestModel): Promise<SpecificationGroupSearchProductResponseOfProductCardModel> {
        let url_ = this.baseUrl + "/api/{catalog}/search";
        if (catalog === undefined || catalog === null)
            throw new Error("The parameter 'catalog' must be defined.");
        url_ = url_.replace("{catalog}", encodeURIComponent("" + catalog));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processSearch(_response);
        });
    }

    protected processSearch(response: Response): Promise<SpecificationGroupSearchProductResponseOfProductCardModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as SpecificationGroupSearchProductResponseOfProductCardModel;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ValidationErrorResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SpecificationGroupSearchProductResponseOfProductCardModel>(null as any);
    }
}

export class ByIdMediaApiClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "https://localhost:44376";
    }

    /**
     * @deprecated
     */
    byId(id: string): Promise<IApiMediaWithCropsResponse> {
        let url_ = this.baseUrl + "/umbraco/delivery/api/v1/media/item/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processById(_response);
        });
    }

    protected processById(response: Response): Promise<IApiMediaWithCropsResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as IApiMediaWithCropsResponse;
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<IApiMediaWithCropsResponse>(null as any);
    }

    /**
     * Gets a media item by id.
     * @param id The unique identifier of the media item.
     * @return The media item or not found result.
     */
    byIdV20(id: string): Promise<IApiMediaWithCropsResponse> {
        let url_ = this.baseUrl + "/umbraco/delivery/api/v2/media/item/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processByIdV20(_response);
        });
    }

    protected processByIdV20(response: Response): Promise<IApiMediaWithCropsResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as IApiMediaWithCropsResponse;
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<IApiMediaWithCropsResponse>(null as any);
    }
}

export class ByIdsMediaApiClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "https://localhost:44376";
    }

    /**
     * @param ids (optional)
     * @deprecated
     */
    item(ids: string[] | undefined): Promise<IApiMediaWithCropsResponse[]> {
        let url_ = this.baseUrl + "/umbraco/delivery/api/v1/media/item?";
        if (ids === null)
            throw new Error("The parameter 'ids' cannot be null.");
        else if (ids !== undefined)
            ids && ids.forEach(item => { url_ += "id=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processItem(_response);
        });
    }

    protected processItem(response: Response): Promise<IApiMediaWithCropsResponse[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as IApiMediaWithCropsResponse[];
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<IApiMediaWithCropsResponse[]>(null as any);
    }

    /**
     * Gets media items by ids.
     * @param ids (optional) The unique identifiers of the media items to retrieve.
     * @return The media items.
     */
    itemsV20(ids: string[] | undefined): Promise<IApiMediaWithCropsResponse[]> {
        let url_ = this.baseUrl + "/umbraco/delivery/api/v2/media/items?";
        if (ids === null)
            throw new Error("The parameter 'ids' cannot be null.");
        else if (ids !== undefined)
            ids && ids.forEach(item => { url_ += "id=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processItemsV20(_response);
        });
    }

    protected processItemsV20(response: Response): Promise<IApiMediaWithCropsResponse[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as IApiMediaWithCropsResponse[];
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<IApiMediaWithCropsResponse[]>(null as any);
    }
}

export class ByPathMediaApiClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "https://localhost:44376";
    }

    /**
     * @deprecated
     */
    byPath(path: string): Promise<IApiMediaWithCropsResponse> {
        let url_ = this.baseUrl + "/umbraco/delivery/api/v1/media/item/{path}";
        if (path === undefined || path === null)
            throw new Error("The parameter 'path' must be defined.");
        url_ = url_.replace("{path}", encodeURIComponent("" + path));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processByPath(_response);
        });
    }

    protected processByPath(response: Response): Promise<IApiMediaWithCropsResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as IApiMediaWithCropsResponse;
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<IApiMediaWithCropsResponse>(null as any);
    }

    /**
     * Gets a media item by its path.
     * @param path The path of the media item.
     * @return The media item or not found result.
     */
    byPathV20(path: string): Promise<IApiMediaWithCropsResponse> {
        let url_ = this.baseUrl + "/umbraco/delivery/api/v2/media/item/{path}";
        if (path === undefined || path === null)
            throw new Error("The parameter 'path' must be defined.");
        url_ = url_.replace("{path}", encodeURIComponent("" + path));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processByPathV20(_response);
        });
    }

    protected processByPathV20(response: Response): Promise<IApiMediaWithCropsResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as IApiMediaWithCropsResponse;
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<IApiMediaWithCropsResponse>(null as any);
    }
}

export class QueryMediaApiClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "https://localhost:44376";
    }

    /**
     * @param fetch (optional)
     * @param filter (optional)
     * @param sort (optional)
     * @param skip (optional)
     * @param take (optional)
     * @deprecated
     */
    query(fetch: string | null | undefined, filter: string[] | undefined, sort: string[] | undefined, skip: number | undefined, take: number | undefined): Promise<PagedViewModelOfIApiMediaWithCropsResponse> {
        let url_ = this.baseUrl + "/umbraco/delivery/api/v1/media?";
        if (fetch !== undefined && fetch !== null)
            url_ += "fetch=" + encodeURIComponent("" + fetch) + "&";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            filter && filter.forEach(item => { url_ += "filter=" + encodeURIComponent("" + item) + "&"; });
        if (sort === null)
            throw new Error("The parameter 'sort' cannot be null.");
        else if (sort !== undefined)
            sort && sort.forEach(item => { url_ += "sort=" + encodeURIComponent("" + item) + "&"; });
        if (skip === null)
            throw new Error("The parameter 'skip' cannot be null.");
        else if (skip !== undefined)
            url_ += "skip=" + encodeURIComponent("" + skip) + "&";
        if (take === null)
            throw new Error("The parameter 'take' cannot be null.");
        else if (take !== undefined)
            url_ += "take=" + encodeURIComponent("" + take) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processQuery(_response);
        });
    }

    protected processQuery(response: Response): Promise<PagedViewModelOfIApiMediaWithCropsResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as PagedViewModelOfIApiMediaWithCropsResponse;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PagedViewModelOfIApiMediaWithCropsResponse>(null as any);
    }

    /**
     * Gets a paginated list of media item(s) from query.
     * @param fetch (optional) Optional fetch query parameter value.
     * @param filter (optional) Optional filter query parameters values.
     * @param sort (optional) Optional sort query parameters values.
     * @param skip (optional) The amount of items to skip.
     * @param take (optional) The amount of items to take.
     * @return The paged result of the media item(s).
     */
    queryV20(fetch: string | null | undefined, filter: string[] | undefined, sort: string[] | undefined, skip: number | undefined, take: number | undefined): Promise<PagedViewModelOfIApiMediaWithCropsResponse> {
        let url_ = this.baseUrl + "/umbraco/delivery/api/v2/media?";
        if (fetch !== undefined && fetch !== null)
            url_ += "fetch=" + encodeURIComponent("" + fetch) + "&";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            filter && filter.forEach(item => { url_ += "filter=" + encodeURIComponent("" + item) + "&"; });
        if (sort === null)
            throw new Error("The parameter 'sort' cannot be null.");
        else if (sort !== undefined)
            sort && sort.forEach(item => { url_ += "sort=" + encodeURIComponent("" + item) + "&"; });
        if (skip === null)
            throw new Error("The parameter 'skip' cannot be null.");
        else if (skip !== undefined)
            url_ += "skip=" + encodeURIComponent("" + skip) + "&";
        if (take === null)
            throw new Error("The parameter 'take' cannot be null.");
        else if (take !== undefined)
            url_ += "take=" + encodeURIComponent("" + take) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processQueryV20(_response);
        });
    }

    protected processQueryV20(response: Response): Promise<PagedViewModelOfIApiMediaWithCropsResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as PagedViewModelOfIApiMediaWithCropsResponse;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PagedViewModelOfIApiMediaWithCropsResponse>(null as any);
    }
}

export class ByIdContentApiClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "https://localhost:44376";
    }

    /**
     * @deprecated
     */
    byId(id: string): Promise<IApiContentResponse> {
        let url_ = this.baseUrl + "/umbraco/delivery/api/v1/content/item/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processById(_response);
        });
    }

    protected processById(response: Response): Promise<IApiContentResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as IApiContentResponse;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<IApiContentResponse>(null as any);
    }

    /**
     * Gets a content item by id.
     * @param id The unique identifier of the content item.
     * @return The content item or not found result.
     */
    byIdV20(id: string): Promise<IApiContentResponse> {
        let url_ = this.baseUrl + "/umbraco/delivery/api/v2/content/item/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processByIdV20(_response);
        });
    }

    protected processByIdV20(response: Response): Promise<IApiContentResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as IApiContentResponse;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<IApiContentResponse>(null as any);
    }
}

export class ByIdsContentApiClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "https://localhost:44376";
    }

    /**
     * @param ids (optional)
     * @deprecated
     */
    item(ids: string[] | undefined): Promise<IApiContentResponse[]> {
        let url_ = this.baseUrl + "/umbraco/delivery/api/v1/content/item?";
        if (ids === null)
            throw new Error("The parameter 'ids' cannot be null.");
        else if (ids !== undefined)
            ids && ids.forEach(item => { url_ += "id=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processItem(_response);
        });
    }

    protected processItem(response: Response): Promise<IApiContentResponse[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as IApiContentResponse[];
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<IApiContentResponse[]>(null as any);
    }

    /**
     * Gets content items by ids.
     * @param ids (optional) The unique identifiers of the content items to retrieve.
     * @return The content items.
     */
    itemsV20(ids: string[] | undefined): Promise<IApiContentResponse[]> {
        let url_ = this.baseUrl + "/umbraco/delivery/api/v2/content/items?";
        if (ids === null)
            throw new Error("The parameter 'ids' cannot be null.");
        else if (ids !== undefined)
            ids && ids.forEach(item => { url_ += "id=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processItemsV20(_response);
        });
    }

    protected processItemsV20(response: Response): Promise<IApiContentResponse[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as IApiContentResponse[];
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<IApiContentResponse[]>(null as any);
    }
}

export class ByRouteContentApiClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "https://localhost:44376";
    }

    /**
     * @deprecated
     */
    byRoute(path: string): Promise<IApiContentResponse> {
        let url_ = this.baseUrl + "/umbraco/delivery/api/v1/content/item/{path}";
        if (path === undefined || path === null)
            throw new Error("The parameter 'path' must be defined.");
        url_ = url_.replace("{path}", encodeURIComponent("" + path));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processByRoute(_response);
        });
    }

    protected processByRoute(response: Response): Promise<IApiContentResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as IApiContentResponse;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<IApiContentResponse>(null as any);
    }

    /**
     * Gets a content item by route.
     * @param path The path to the content item.
     * @return The content item or not found result.
     */
    byRouteV20(path: string): Promise<IApiContentResponse> {
        let url_ = this.baseUrl + "/umbraco/delivery/api/v2/content/item/{path}";
        if (path === undefined || path === null)
            throw new Error("The parameter 'path' must be defined.");
        url_ = url_.replace("{path}", encodeURIComponent("" + path));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processByRouteV20(_response);
        });
    }

    protected processByRouteV20(response: Response): Promise<IApiContentResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as IApiContentResponse;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<IApiContentResponse>(null as any);
    }
}

export class QueryContentApiClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "https://localhost:44376";
    }

    /**
     * @param fetch (optional)
     * @param filter (optional)
     * @param sort (optional)
     * @param skip (optional)
     * @param take (optional)
     * @deprecated
     */
    query(fetch: string | null | undefined, filter: string[] | undefined, sort: string[] | undefined, skip: number | undefined, take: number | undefined): Promise<PagedViewModelOfIApiContentResponse> {
        let url_ = this.baseUrl + "/umbraco/delivery/api/v1/content?";
        if (fetch !== undefined && fetch !== null)
            url_ += "fetch=" + encodeURIComponent("" + fetch) + "&";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            filter && filter.forEach(item => { url_ += "filter=" + encodeURIComponent("" + item) + "&"; });
        if (sort === null)
            throw new Error("The parameter 'sort' cannot be null.");
        else if (sort !== undefined)
            sort && sort.forEach(item => { url_ += "sort=" + encodeURIComponent("" + item) + "&"; });
        if (skip === null)
            throw new Error("The parameter 'skip' cannot be null.");
        else if (skip !== undefined)
            url_ += "skip=" + encodeURIComponent("" + skip) + "&";
        if (take === null)
            throw new Error("The parameter 'take' cannot be null.");
        else if (take !== undefined)
            url_ += "take=" + encodeURIComponent("" + take) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processQuery(_response);
        });
    }

    protected processQuery(response: Response): Promise<PagedViewModelOfIApiContentResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as PagedViewModelOfIApiContentResponse;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PagedViewModelOfIApiContentResponse>(null as any);
    }

    /**
     * Gets a paginated list of content item(s) from query.
     * @param fetch (optional) Optional fetch query parameter value.
     * @param filter (optional) Optional filter query parameters values.
     * @param sort (optional) Optional sort query parameters values.
     * @param skip (optional) The amount of items to skip.
     * @param take (optional) The amount of items to take.
     * @return The paged result of the content item(s).
     */
    queryV20(fetch: string | null | undefined, filter: string[] | undefined, sort: string[] | undefined, skip: number | undefined, take: number | undefined): Promise<PagedViewModelOfIApiContentResponse> {
        let url_ = this.baseUrl + "/umbraco/delivery/api/v2/content?";
        if (fetch !== undefined && fetch !== null)
            url_ += "fetch=" + encodeURIComponent("" + fetch) + "&";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            filter && filter.forEach(item => { url_ += "filter=" + encodeURIComponent("" + item) + "&"; });
        if (sort === null)
            throw new Error("The parameter 'sort' cannot be null.");
        else if (sort !== undefined)
            sort && sort.forEach(item => { url_ += "sort=" + encodeURIComponent("" + item) + "&"; });
        if (skip === null)
            throw new Error("The parameter 'skip' cannot be null.");
        else if (skip !== undefined)
            url_ += "skip=" + encodeURIComponent("" + skip) + "&";
        if (take === null)
            throw new Error("The parameter 'take' cannot be null.");
        else if (take !== undefined)
            url_ += "take=" + encodeURIComponent("" + take) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processQueryV20(_response);
        });
    }

    protected processQueryV20(response: Response): Promise<PagedViewModelOfIApiContentResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as PagedViewModelOfIApiContentResponse;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PagedViewModelOfIApiContentResponse>(null as any);
    }
}

export interface BasketResponseModel {
    basketReturn?: BasketReturnModel;
    shippingMethods?: (ShippingMethodReturnModel | undefined)[] | undefined;
}

export interface BasketReturnModel {
    basketId?: string;
    marketId?: string;
    lines?: LineItemReturnModel[];
    billingAddress?: Address;
    shippingAddress?: Address;
    useBillingAddressForShipping?: boolean;
    note?: string | undefined;
    acceptNewsletter?: boolean;
    acceptTerms?: boolean;
    subtotal?: Money | undefined;
    subtotalVat?: Money | undefined;
    shippingTotal?: Money | undefined;
    shippingTotalVat?: Money | undefined;
    ecoFee?: Money | undefined;
    ecoFeeVat?: Money | undefined;
    total?: Money | undefined;
    totalVat?: Money | undefined;
    totalDiscount?: Money | undefined;
    remainingTotal?: Money | undefined;
    paidTotal?: Money | undefined;
    estimatedShippingCost?: Money | undefined;
    currency?: string | undefined;
    quantity?: number;
    paymentTerms?: PaymentTerms | undefined;
    promoCodes?: string[];
    created?: Date;
    updated?: Date;
    orderState?: string | undefined;
    customer?: string;
    cvr?: string | undefined;
    gln?: string | undefined;
    invoiceDetail?: InvoiceDetail | undefined;
    payments?: PaymentReturnModel[];
    shipments?: ShipmentReturnModel[];
}

export interface LineItemReturnModel {
    saleUnitSize?: number;
    imageUrl?: string | undefined;
    productUrl?: string | undefined;
    parentId?: string | undefined;
    unitPrice?: Price;
    totalPrice?: Price;
    groupTotalPrice?: Price | undefined;
    id?: string;
    sku?: string;
    name?: string;
    description?: string | undefined;
    addons?: LineItemReturnModel[] | undefined;
    indicators?: Indicator[];
    googleProductCategory?: string | undefined;
    quantity?: number;
    brand?: string | undefined;
    designer?: string | undefined;
    sortOrder?: number | undefined;
    variantOptions?: LineItemSelectedVariantOption[];
}

export interface ValueObjectOfPrice {
}

export interface Price extends ValueObjectOfPrice {
    id?: string;
    listPrice?: Money;
    salesPrice?: Money;
    vatAmount?: Money;
    vatRate?: number;
    discounts?: Discount[];
    quantityPrices?: { [key: string]: QuantityPrice; } | undefined;
}

export interface ValueObjectOfMoney {
}

export interface Money extends ValueObjectOfMoney {
    amount?: number;
    currency?: string;
}

export interface Discount {
    currency?: string | undefined;
    type?: string;
    amount?: number;
    reference?: string;
}

export interface ValueObjectOfQuantityPrice {
}

export interface QuantityPrice extends ValueObjectOfQuantityPrice {
    totalSalesPrice?: Money;
    id?: string;
    listPrice?: Money;
    salesPrice?: Money;
    vatAmount?: Money;
    vatRate?: number;
    discounts?: Discount[];
    quantityPriceDescriptor?: string | undefined;
}

export interface Indicator {
    text?: string;
    textColor?: string | undefined;
    backgroundColor?: string | undefined;
    display?: string | undefined;
}

export interface LineItemSelectedVariantOption {
    title?: string;
    value?: string;
    id?: number;
}

export interface Address {
    firstName?: string | undefined;
    lastName?: string | undefined;
    organizationName?: string | undefined;
    line1?: string | undefined;
    line2?: string | undefined;
    city?: string | undefined;
    postalCode?: string | undefined;
    regionCode?: string | undefined;
    country?: string | undefined;
    phoneNumber?: string | undefined;
    mobilePhoneNumber?: string | undefined;
    email?: string | undefined;
}

export interface PaymentTerms {
    name?: string;
    description?: string;
    pct?: number;
    catalogId?: string | undefined;
    invItemKey?: string;
    id?: string;
    amount?: Money | undefined;
    vat?: Money | undefined;
    showOnWebB2C?: boolean;
    showOnWebB2B?: boolean;
    sorting?: number;
}

export interface InvoiceDetail {
    emails?: string[];
    referenceNumber?: string;
}

export interface PaymentReturnModel {
    id?: string;
    provider?: string;
    paymentMethodId?: string;
    amount?: Money;
    fields?: { [key: string]: string; } | undefined;
    paymentOperations?: PaymentOperation[] | undefined;
    transactionId?: PaymentTransactionId | undefined;
    fee?: Money;
    created?: Date;
    completed?: Date | undefined;
    paymentState?: string;
    amountCaptured?: Money;
    amountRefunded?: Money;
}

export interface PaymentOperation {
    created?: Date;
    type?: string | undefined;
    correlationId?: string | undefined;
    eventCode?: string | undefined;
    success?: boolean | undefined;
    merchantReference?: string | undefined;
    reason?: string | undefined;
}

export interface ValueObjectOfPaymentTransactionId {
}

export interface PaymentTransactionId extends ValueObjectOfPaymentTransactionId {
    value?: string;
}

export interface ShipmentReturnModel {
    id?: string;
    shippingMethodId?: string;
    price?: Price | undefined;
    shippingMethodName?: string;
    pickupPointId?: string | undefined;
    pickupPointAddress?: Address | undefined;
    shippingMethodType?: string;
}

export interface ShippingMethodReturnModel {
    sortOrder?: number | undefined;
    productReference?: string | undefined;
    price?: Price | undefined;
    description?: string | undefined;
    name?: string;
    id?: string;
    pickupPointProvider?: string | undefined;
    shippingMethodType?: string;
}

export interface ValidationErrorResponse {
    status?: number;
    messages?: ValidationMessage[];
}

export interface ValidationMessage {
    property?: string | undefined;
    message?: string;
}

export interface UpdateBasketAddressModel {
    billingAddress: Address;
    shippingAddress?: Address | undefined;
}

export interface InvoiceDetailRequestModel {
    referenceNumber?: string | undefined;
    invoiceEmail?: string | undefined;
}

export interface SetCustomerTypeRequestBody {
    type?: CustomerType;
}

export enum CustomerType {
    Private = "Private",
    Public = "Public",
    Company = "Company",
}

export interface UpdateShippingModel {
    shippingMethodId?: string | undefined;
    pickupPointId?: string | undefined;
}

export interface PickupPoint {
    id?: string;
    address?: Address;
    straightLineDistance?: number;
    latitude?: number;
    longitude?: number;
}

export interface PaymentMethod {
    id?: string;
    description?: string | undefined;
    name?: string | undefined;
    amount?: Money | undefined;
    vat?: Money | undefined;
}

export interface PaymentMethodModel extends PaymentMethod {
    sortOrder?: number;
}

export interface AddBasketLineItemsModel {
    groupLine?: AddLineItemModel | undefined;
    replaces?: string | undefined;
    lines?: AddLineItemModel[];
}

export interface AddLineItemModel {
    sku?: string;
    quantity?: number;
}

export interface OrderResponseModel {
    orderReturn?: OrderReturnModel;
    isTracked?: boolean;
}

export interface OrderReturnModel {
    invoiceDetail?: InvoiceDetail | undefined;
    orderId?: string;
    marketId?: string;
    lines?: LineItemReturnModel[];
    billingAddress?: Address;
    shippingAddress?: Address;
    useBillingAddressForShipping?: boolean;
    note?: string;
    acceptNewsletter?: boolean;
    acceptTerms?: boolean;
    subtotal?: Money | undefined;
    subtotalVat?: Money | undefined;
    shippingTotal?: Money | undefined;
    shippingTotalVat?: Money | undefined;
    ecoFee?: Money | undefined;
    ecoFeeVat?: Money | undefined;
    total?: Money | undefined;
    totalVat?: Money | undefined;
    totalDiscount?: Money | undefined;
    currency?: string | undefined;
    paymentTerms?: PaymentTerms | undefined;
    orderNumber?: string;
    promoCodes?: string[];
    created?: Date;
    updated?: Date;
    orderState?: string;
    cvr?: string | undefined;
    gln?: string | undefined;
    reference?: string | undefined;
    paymentInformation?: OrderPaymentInformation;
    shipments?: ShipmentReturnModel[];
}

export interface OrderPaymentInformation {
    paymentType?: string | undefined;
}

export interface NewsletterPostBody {
    email: string;
    firstName: string;
    lastName: string;
    source: Origin;
    phoneNumber?: string | undefined;
}

export enum Origin {
    Inquiry = "Inquiry",
    Purchase = "Purchase",
}

export interface ProblemDetails {
    type?: string | undefined;
    title?: string | undefined;
    status?: number | undefined;
    detail?: string | undefined;
    instance?: string | undefined;
    extensions?: { [key: string]: any; };

    [key: string]: any;
}

export interface CompanyResponseModel {
    companyName?: string;
    vatNumber?: string;
    address?: string;
    zipCode?: string;
    city?: string;
    countryCode?: string;
}

export interface ProductModel {
    documents?: DocumentModel[] | undefined;
    shortDescription?: string | undefined;
    longDescription?: string | undefined;
    relatedProducts?: { [key: string]: string[]; };
    price?: Price | undefined;
    primaryTag?: string | undefined;
    productType?: string;
    seoTitle?: string;
    estimatedShippingPrice?: Price | undefined;
    seoDescription?: string;
    id?: string;
    name?: string;
    url?: string | undefined;
    addons?: AddonModel[];
    designer?: string;
    googleProductCategory?: string | undefined;
    variantGroups?: { [key: string]: VariantGroup; };
    variantTypes?: VariantType[];
    variantPrices?: { [key: string]: string; } | undefined;
    options?: { [key: string]: VariantOption; };
    specifications?: Specification[];
    brand?: string;
    brandUrlSegment?: string;
    images?: string[];
    indicators?: Indicator[];
    saleUnitSize?: number;
    campaignFrom?: Date | undefined;
    campaignTo?: Date | undefined;
    priceDictionary?: { [key: string]: Price; };
    categoryGroupCustomizerSelectionTitle?: string | undefined;
}

export interface DocumentModel {
    id?: string;
    url?: string;
    label?: string | undefined;
}

export interface AddonModel {
    brand?: string | undefined;
    googleProductCategory?: string | undefined;
    options?: { [key: string]: VariantOption; };
    productType?: string | undefined;
    variantPrices?: { [key: string]: string; } | undefined;
    variantTypes?: VariantType[] | undefined;
    images?: string[] | undefined;
    priceDictionary?: { [key: string]: Price; } | undefined;
    price?: Price | undefined;
    id?: string | undefined;
}

export interface ValueObjectOfVariantOption {
}

export interface VariantOption extends ValueObjectOfVariantOption {
    id?: string;
    name?: string;
    description?: string | undefined;
    imageUrl?: string | undefined;
    sortOrder?: number | undefined;
    groupId?: string;
    translatedSpecifications?: string[];
    specifications?: Specification | undefined;
}

export interface Specification {
    name?: string;
    group?: SpecificationGroup | undefined;
    value?: any | undefined;
    unit?: string | undefined;
    useAsFacet?: boolean;
    sortOrder?: number;
    type?: string;
}

export interface SpecificationGroup {
    id?: string;
    name?: string;
    sortOrder?: number;
}

export interface VariantType {
    type?: string;
    title?: string;
    longTitle?: string | undefined;
    description?: string | undefined;
    view?: string | undefined;
    index?: number;
}

export interface VariantGroup {
    id?: string;
    title?: string | undefined;
    description?: string | undefined;
    sortOrder?: number;
}

export interface SendProductInquiryRequestBody {
    firstName: string;
    lastName: string;
    email: string;
    telephone?: string | undefined;
    company?: string | undefined;
    comment?: string | undefined;
    url?: string | undefined;
}

export interface CustomizerModel {
    total?: Price | undefined;
    product?: ProductModel;
    content?: any | undefined;
}

export interface ProductCustomizerRequestModel {
    product?: string;
    selectedAddons?: string[];
}

export interface SearchProductResponseOfProductCardModel {
    results?: ProductCardModel[];
    startingFrom?: number;
    totalResults?: number;
    facets?: FacetModel[];
    sortings?: SortingModel[];
    searchTerms?: string;
}

export interface SpecificationGroupSearchProductResponseOfProductCardModel extends SearchProductResponseOfProductCardModel {
    foundSpecificationGroups?: { [key: string]: string[]; } | undefined;
    facetGroups?: FacetGroupModel[];
}

export interface FacetGroupModel {
    id?: string | undefined;
    name?: string | undefined;
    sortOrder?: number;
}

export interface ProductCardModel {
    images?: string[];
    indicators?: Indicator[];
    price?: Price | undefined;
    googleProductCategory?: string | undefined;
    affiliation?: string | undefined;
    brand?: string | undefined;
    id?: string | undefined;
    name?: string | undefined;
    url?: string | undefined;
    designer?: string;
    relatedProducts?: { [key: string]: string[]; };
    addons?: ProductAddonCard[];
    selectedOptions?: string[] | undefined;
    shortDescription?: string | undefined;
    columnSpan?: number;
}

export interface ProductAddonCard {
    id?: string | undefined;
    brand?: string | undefined;
    googleProductCategory?: string | undefined;
    selectedOptions?: string[];
    variantId?: string | undefined;
    product?: string | undefined;
    name?: string | undefined;
}

export interface FacetBaseOfFacetValueOfString {
    id?: string;
    values?: FacetValueOfString[];
}

export interface FacetModel extends FacetBaseOfFacetValueOfString {
    title?: string;
}

export interface FacetValueOfString {
    value?: string | undefined;
    count?: number;
    selected?: boolean;
    title?: string | undefined;
}

export interface SortingModel {
    id?: string;
    selected?: boolean;
}

export interface SearchRequestModel {
    from?: number | undefined;
    size?: number | undefined;
    searchTerms?: string | undefined;
    sorting?: string | undefined;
    priceRangeInterval?: number | undefined;
    facets?: { [key: string]: string[]; } | undefined;
    tags?: string[][];
}

export interface IApiMediaWithCropsResponse {
    path?: string;
    createDate?: Date;
    updateDate?: Date;
}

export interface PagedViewModelOfIApiMediaWithCropsResponse {
    total: number;
    items: IApiMediaWithCropsResponse[];
}

export interface IApiContentResponse {
    cultures?: { [key: string]: IApiContentRoute; };
}

export interface IApiContentRoute {
    path?: string;
    startItem?: IApiContentStartItem;
}

export interface IApiContentStartItem {
    id?: string;
    path?: string;
}

export interface PagedViewModelOfIApiContentResponse {
    total: number;
    items: IApiContentResponse[];
}

export class SwaggerException extends Error {
    override message: string;
    status: number;
    response: string;
    headers: { [key: string]: any; };
    result: any;

    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isSwaggerException = true;

    static isSwaggerException(obj: any): obj is SwaggerException {
        return obj.isSwaggerException === true;
    }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): any {
    if (result !== null && result !== undefined)
        throw result;
    else
        throw new SwaggerException(message, status, response, headers, null);
}
